import {takeLatest, takeEvery, all} from 'redux-saga/effects';
import {put} from 'redux-saga/effects';
import {actions, actionTypes} from '../Redux/index';
import { LOCAL_STORAGE_KEYS } from '../constants';

const parse = (it) => {
    try {
        return JSON.parse(it);
    } catch (e) {
        console.error(e);
        return null;
    }
}

function* loadLocalStorage() {
    const homeOptions = window.localStorage.getItem(LOCAL_STORAGE_KEYS.HOME_OPTIONS);
    if(homeOptions) {
        yield put(actions.UI.HomeOptions.changeHomeOptions(parse(homeOptions)));
    }

    const settlementOptions = window.localStorage.getItem(LOCAL_STORAGE_KEYS.SETTLEMENT_OPTIONS);
    if(settlementOptions) {
        yield put(actions.UI.SettlementOptions.changeSettlementOptions(parse(settlementOptions)));
    }

    const forwardOptions = window.localStorage.getItem(LOCAL_STORAGE_KEYS.FORWARD_OPTIONS);
    if (forwardOptions) {
        yield put(actions.UI.ForwardOptions.changeForwardOptions(parse(forwardOptions)));
    }

    const spotOptions = window.localStorage.getItem(LOCAL_STORAGE_KEYS.SPOT_OPTIONS);
    if (spotOptions) {
        yield put(actions.UI.SpotOptions.changeSpotOptions(parse(spotOptions)));
    }

    yield put({ type: 'LOCAL_STORAGE_READY' });
}

function* saveLocalStorage(args) {
    if (args.payload && args.payload.hasOwnProperty('lang')){
        window.localStorage.setItem(LOCAL_STORAGE_KEYS.LOCALE, args.payload.lang);
    }

    if (args.payload && args.payload.homeOptions){
        window.localStorage.setItem(LOCAL_STORAGE_KEYS.HOME_OPTIONS, JSON.stringify(args.payload.homeOptions));
        yield put(actions.Data.Reload.sagaReloadData({ options: args.payload.homeOptions }));
    }

    if (args.payload && args.payload.spotOptions){
        window.localStorage.setItem(LOCAL_STORAGE_KEYS.SPOT_OPTIONS, JSON.stringify(args.payload.spotOptions));
        yield put(actions.Data.Reload.sagaReloadData({ options: args.payload.spotOptions }));
    }

    if (args.payload && args.payload.forwardOptions){
        window.localStorage.setItem(LOCAL_STORAGE_KEYS.FORWARD_OPTIONS, JSON.stringify(args.payload.forwardOptions));
        yield put(actions.Data.Reload.sagaReloadData({ options: args.payload.forwardOptions }));
    }

    if (args.payload && args.payload.settlementOptions){
        window.localStorage.setItem(LOCAL_STORAGE_KEYS.SETTLEMENT_OPTIONS, JSON.stringify(args.payload.settlementOptions));
        yield put(actions.Data.Reload.sagaReloadData({ options: args.payload.settlementOptions }));
    }
}

export default function* localStorage(){
    yield all([
        takeEvery(actionTypes.System.INIT, loadLocalStorage),
        takeLatest(actionTypes.UI.Locale.CHANGE_LANGUAGE, saveLocalStorage),
        takeLatest(actionTypes.UI.HomeOptions.CHANGE_HOME_OPTIONS, saveLocalStorage),
        takeLatest(actionTypes.UI.SpotOptions.CHANGE_SPOT_OPTIONS, saveLocalStorage),
        takeLatest(actionTypes.UI.ForwardOptions.CHANGE_FORWARD_OPTIONS, saveLocalStorage),
        takeLatest(actionTypes.UI.SettlementOptions.CHANGE_SETTLEMENT_OPTIONS, saveLocalStorage)
    ])
}